import * as api from "@/api/williams/report";
import { PrintDialog } from "../dialogs";
import { useModalDialog } from "@/hooks";
import { WelderPrintOptions } from "@/api/williams/report";

export function usePrintWelder() {
  const dialog = useModalDialog();

  function showDialog(welderId: string | string[]) {
    dialog.show(PrintDialog, {
      onAccept: (options: WelderPrintOptions) => api.printWelder(welderId, options),
    });
  }

  return { showDialog };
}
